import {FC} from 'react'

const DobCellData = (props: any) => {
let date = new Date(props?.tableProps);
let formattedDate = date.toISOString().split('T')[0]; 
  return (
    <div className='d-flex ms-5 '>
      <span className='text-black fw-bold fs-7 '>{formattedDate}</span>
    </div>
  )
}

export {DobCellData}
